import { Children, ElementType } from 'react';

import cx from '@/lib/cx';
import ContextMenuLink from './ContextMenuLink';

type ContextMenuProps<C extends ElementType> = PolymorphicComponentProp<
  C,
  {
    bordered?: boolean;
    className?: string;
    children: NonEmptyReactNode;
  }
>;

const ContextMenu = <C extends ElementType = 'div'>({
  as,
  bordered = false,
  className = '',
  children,
}: ContextMenuProps<C>) => {
  const Component = as || 'div';
  const items = Children.toArray(children);

  return (
    <Component className={className}>
      {items.map((item, i) => (
        <div
          key={i}
          className={cx('py-px', {
            'border-t border-gray-300 lg:border-t-0': bordered,
          })}
        >
          {item}
        </div>
      ))}
    </Component>
  );
};

ContextMenu.Link = ContextMenuLink;

export default ContextMenu;
